import { PovahaHromadnejPripomienkyEnum } from 'pripomienky-web-ts-axios';

enum PovahaPripomienky {
  ZASADNA = 'Zásadná',
  OBYCAJNA = 'Obyčajná',
  ZASADNA_S_ROZPOROM = 'Zásadná s rozporom',
}

export default PovahaPripomienky;

export const generatedToPovahaPripomienkyMap = new Map([
  [PovahaHromadnejPripomienkyEnum.Zasadna, PovahaPripomienky.ZASADNA],
  [PovahaHromadnejPripomienkyEnum.Obycajna, PovahaPripomienky.OBYCAJNA],
  [PovahaHromadnejPripomienkyEnum.ZasadnaSRozporom, PovahaPripomienky.ZASADNA_S_ROZPOROM],
]);

export const PovahaPripomienkyToGeneratedMap = new Map([
  [PovahaPripomienky.ZASADNA, PovahaHromadnejPripomienkyEnum.Zasadna],
  [PovahaPripomienky.OBYCAJNA, PovahaHromadnejPripomienkyEnum.Obycajna],
  [PovahaPripomienky.ZASADNA_S_ROZPOROM, PovahaHromadnejPripomienkyEnum.ZasadnaSRozporom],
]);

export const povahaPripomienkyArray = [
  [PovahaPripomienky.ZASADNA],
  [PovahaPripomienky.OBYCAJNA],
  [PovahaPripomienky.ZASADNA_S_ROZPOROM],
];

export function generatedToPovahaPripomienky(generated: PovahaHromadnejPripomienkyEnum): PovahaPripomienky {
  return generatedToPovahaPripomienkyMap.get(generated);
}

export function povahaPripomienkyToGenerated(povahaPripomienky: PovahaPripomienky): PovahaHromadnejPripomienkyEnum {
  return PovahaPripomienkyToGeneratedMap.get(povahaPripomienky);
}
